export const INVALID_OFFER_MESSAGE = 'CHECKOUT.OFFER.ERROR.INACTIVE';

export const INVALID_PREODER_REVIEW_ERRORS = [
    'shopping_cart_validation.offer_not_active',
    'shopping_cart_validation.not_enough_stock',
    'preorder_validation.shipping_address_contains_restricted_area'
] as const;